import moment from "moment";

const diffBetweenDays = (from, to) => {
  const timeDiff = new Date(to).getTime() - new Date(from).getTime();
  const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
  return isNaN(diffDays) ? -1 : diffDays;
};

const formatDate = (date, format = "DD MMM YYYY", locale = "en") => {
  return moment(date)
    .locale(locale)
    .format(Array.isArray(format) ? format[0] : format);
};

const parseDate = (str, format = "DD MMM YYYY", locale = "en") => {
  const trimmedStr = str ? str.trim() : str;
  if (!trimmedStr) return undefined;

  const formats = [
    format,
    "DD/MM/YYYY",
    "DD-MM-YYYY",
    "DD.MM.YYYY",
    "DD MMM YYYY",
    "DD MMMM YYYY",
    "YYYY-MM-DD",
    "YYYY/MM/DD",
    "MM/DD/YYYY",
    "MM-DD-YYYY",
    "D/M/YYYY",
    "D-M-YYYY",
    "D MMM YYYY",
    "D MMMM YYYY",
  ];

  for (const fmt of formats) {
    const m = moment(trimmedStr, fmt, locale, true);
    if (m.isValid()) {
      return m.toDate();
    }
  }

  const fallback = moment(trimmedStr, locale);
  if (fallback.isValid()) {
    return fallback.toDate();
  }

  return undefined;
};

export { diffBetweenDays, formatDate, parseDate };
